document.addEventListener('DOMContentLoaded', function () {
    if (!location.href.includes('a/statut-livraison')) return;

    // === Partie 1 : duplication du numéro de suivi (inchangée) ===
    var checked = false;
    var trackingNumberInfo = extractTrackingNumber();
    if (trackingNumberInfo) {
        duplicateTrackingNumber(trackingNumberInfo);
        checked = true;
    }
    if (!checked) {
        var intervalId = setInterval(function () {
            var trackingNumberInfo = extractTrackingNumber();
            if (trackingNumberInfo) {
                duplicateTrackingNumber(trackingNumberInfo);
                clearInterval(intervalId);
            }
        }, 1000);
    }

    function extractTrackingNumber() {
        var trackingInfoElement = document.querySelector('#pp-tracking-page-app > div > div.pp_tracking_result > div.pp_tracking_right > ul > li.PP-SectionItem.PP-Section-CarrierInfo');
        if (trackingInfoElement) {
            var text = trackingInfoElement.textContent || trackingInfoElement.innerText;
            var matchColissimo = text.match(/6A\d{11}/);
            var matchColisPrive = text.match(/Q10\w+/);
            var matchDPD = text.match(/06\d{12}/);

            if (matchColissimo) return { type: 'Colissimo', number: matchColissimo[0] };
            if (matchColisPrive) return { type: 'Colis Privé', number: matchColisPrive[0] };
            if (matchDPD) return { type: 'DPD', number: matchDPD[0] };
        }
        return null;
    }

    function duplicateTrackingNumber(trackingNumberInfo) {
        var firstInsertLocation = document.getElementById('duplicatedTrackingNumberContainer');
        if (firstInsertLocation) {
            var link = document.createElement('a');
            var url;

            if (trackingNumberInfo.type === 'Colissimo') {
                url = 'https://www.laposte.fr/outils/suivre-vos-envois?code=' + trackingNumberInfo.number;
            } else if (trackingNumberInfo.type === 'Colis Privé') {
                url = 'https://colisprive.com/moncolis/pages/detailColis.aspx?numColis=' + trackingNumberInfo.number;
            } else if (trackingNumberInfo.type === 'DPD') {
                url = 'https://www.dpdgroup.com/nl/mydpd/my-parcels/incoming?parcelNumber=' + trackingNumberInfo.number;
            }

            link.href = url;
            link.textContent = 'Cliquez ici pour suivre sur le site de ' + trackingNumberInfo.type;
            link.target = '_blank';

            firstInsertLocation.innerHTML = '';
            firstInsertLocation.appendChild(link);
        }

        var secondInsertLocation = document.getElementById('secondTrackingNumberContainer');
        if (secondInsertLocation) {
            secondInsertLocation.textContent = 'Numéro de suivi: ' + trackingNumberInfo.number;
        }
    }

    // === Utils ===
    function normalize(str) {
        return (str || '').replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function findTrackingTextRoot() {
        return document.querySelector('.pp_tracking_left') ||
               document.querySelector('.pp_tracking_result') ||
               document.body;
    }

    // Forçage du statut principal (sélecteurs robustes)
    function setMainStatus(text) {
        const selectors = [
            'h1.pp_num_status_show.h1.u-h1',
            'h1.pp_num_status_show.u-h1',
            'h1.pp_num_status_show',
            '.pp_num_status_show h1',
            '.pp_num_status h1',
            '.pp_num_status_show .u-h1',
            '.pp_tracking_result h1.u-h1',
            '.pp_tracking_result h1'
        ];
        for (const sel of selectors) {
            const el = document.querySelector(sel);
            if (el) { el.textContent = text; return true; }
        }
        const root = document.querySelector('.pp_tracking_result') || document;
        const heads = root.querySelectorAll('h1, .u-h1');
        for (const h of heads) {
            const t = normalize(h.textContent).toLowerCase();
            if (['commandé','commande prête','en transit','en cours de livraison','livré'].includes(t)) {
                h.textContent = text;
                return true;
            }
        }
        return false;
    }

    // Applique le lock "Commande prête" (avec !important)
    function enforceLockCommandePrete() {
        // Desktop
        const desktopProgressBar = document.querySelector('.progress-bar-style');
        if (desktopProgressBar && desktopProgressBar.style && desktopProgressBar.style.setProperty) {
            desktopProgressBar.style.setProperty('--bar-percent', '25%', 'important');
            desktopProgressBar.style.setProperty('--bar-percent-mobile', '30%', 'important');
        }
        const desktopNodes = document.querySelectorAll('.progress-bar-node');
        desktopNodes.forEach((node, index) => {
            if (index > 1) {
                node.classList.remove('progress-bar-node--active');
                node.classList.add('progress-bar-node-disabled');
            } else {
                node.classList.add('progress-bar-node--active');
                node.classList.remove('progress-bar-node-disabled');
            }
        });

        // Mobile
        const mobileProgressBar = document.querySelector('.progress-bar-mobile-style');
        if (mobileProgressBar && mobileProgressBar.style && mobileProgressBar.style.setProperty) {
            mobileProgressBar.style.setProperty('--bar-percent', '30%', 'important');
            mobileProgressBar.style.setProperty('--bar-percent-mobile', '30%', 'important');
        }
        const mobileSteps = document.querySelectorAll('.progress-bar-mobile-style .progress-bar-mobile-list');
        mobileSteps.forEach((step, index) => {
            if (index > 1) {
                step.classList.remove('progress-bar-mobile-node--active');
                step.classList.add('progress-bar-mobile-disabled');
            } else {
                step.classList.add('progress-bar-mobile-node--active');
                step.classList.remove('progress-bar-mobile-disabled');
            }
        });

        // Statut principal
        setMainStatus('Statut: Commande prête');
    }

    // === Partie 2 : logique avec lock persistant ===
    const phraseRef1 = "Mise à jour du suivi : le colis est en route, avance conformément au planning prévu.";
    const phraseRef2 = "Colis Expédié : Votre colis est entre les mains de notre transporteur privé. Il est actuellement en transit vers les entrepôts de Colissimo - Rappel : Le délai de livraison moyen est de 5 à 7 jours ouvrés.";
    const phrasePreparation = "Votre commande est actuellement en cours de préparation pour l'expédition. Nous mettons tout en œuvre pour qu'elle soit prête à partir le plus rapidement possible. Merci de votre confiance !";

    let lockActive = false;     // si true, on réimpose le lock à chaque mutation
    let scheduled = false;

    function shouldLock() {
        const root = findTrackingTextRoot();
        const text = normalize(root ? root.textContent : '');
        // Priorité aux phrases de référence : si présentes -> pas de lock
        if (text.includes(normalize(phraseRef1)) || text.includes(normalize(phraseRef2))) return false;
        // Si phrase de préparation -> pas de lock
        if (text.includes(normalize(phrasePreparation))) return false;
        // Sinon -> lock
        return true;
    }

    function tick() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(() => {
                try {
                    const needLock = shouldLock();
                    if (needLock) {
                        lockActive = true;
                        enforceLockCommandePrete();
                    } else {
                        lockActive = false; // on laisse ParcelPanel dérouler normalement
                    }
                    // Si le lock est actif, on réimpose à chaque cycle (ParcelPanel peut réécrire)
                    if (lockActive) enforceLockCommandePrete();
                } catch (e) {
                    console.error('[tracking lock] ', e);
                } finally {
                    scheduled = false;
                }
            }, 250); // throttle
        }
    }

    // Observe tout le body (ParcelPanel reconstruit souvent profondément)
    const observer = new MutationObserver(() => {
        tick();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Démarrage + filet de sécurité périodique (faible coût)
    tick();
    const keepAlive = setInterval(() => {
        tick();
        // Optionnel : après 20s, on peut arrêter si pas de lock et pas d’update nécessaire
        // clearInterval(keepAlive);
    }, 1000);
});
